import EmptyState, { Loading } from './EmptyState';

export { Loading };
export default EmptyState;
